<template>
  <div>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.2.0121 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-">رفع باگ سال مالی در پیش فاکتور</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.2.0118 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-"> تغییر نرخ ارزش افزوده به 10 درصد </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.2.0117 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">رفع برخی باگ های اتوماسیون</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.2.0113 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن گزارش کارتابل به اتوماسیون</li>
            <li class="text-secondary mb-1">بهبود عملکرد اتوماسیون</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.2.0111 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن گزارش حسابداری برای درخواست های اتوماسیون</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.2.0110 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> اضافه شدن زیر سیستم اتوماسیون اداری </li>
            <li class="text-secondary mb-1"> اضافه شدن دسترسی های سریع برای مشتریان  </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0109 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود سامانه مودیان </li>
            <li class="text-secondary mb-1"> بهبود صدور قرارداد ها </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0104 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود عملکرد سامانه حقوق دستمزد</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0103 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">  اصلاحات در رنگ مشتریان در چت پشتیبانی </li>
            <li class="text-secondary mb-1"> تهیه نسخه اولیه فرم صورتجلسه  </li>
            <li class="text-secondary mb-1"> رفع اشکال در دسترسی های اندیکاتور </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0100 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود حقوق و دستمزد</li>
            <li class="text-secondary mb-1">اضافه کردن دسترسی صفحه نامه ها</li>
            <li class="text-secondary mb-1">اضافه کردن دسترسی نامه ها بر اساس موضوع</li>
            <li class="text-secondary mb-1">تغییر مقادیر ثابت برنامه</li>
            <li class="text-secondary mb-1">غیر اجباری کردن شماره حساب پیش فاکتور</li>
            <li class="text-secondary mb-1">عدم نمایش پانویس در پیش فاکتور</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
      <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0096 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود کامپوننت مدال</li>
            <li class="text-secondary mb-1"> بستن توانایی مشاهده فایلهای اختصاصی مشتری برای سایرین </li>
            <li class="text-secondary mb-1"> بهبود گزارش مشتریان فعال بدون پشتیبانی </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0095 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> فیکس شدن باگ تاریخ در کپی پیش فاکتور </li>
            <li class="text-secondary mb-1"> بهبود عملکرد کلی </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0093 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبودهای عملکرد سرعت پیشخوان </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0091 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبودهای عملکرد مرکز پشتیبانی </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0088 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبودهای کلی </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0087 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> اصلاح پاک کردن فایلها در مدیریت فایل </li>
            <li class="text-secondary mb-1"> بهبود در جدول نمایش تیکت های مشتری  </li>
            <li class="text-secondary mb-1"> بهبود گزارش توسعه </li>
            <li class="text-secondary mb-1"> بهبود عملکرد نوتیف ها در تیکت ها </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0085 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در قسمت ارجاع تیکت ها </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0084 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در امنیت ورود کاربران </li>
            <li class="text-secondary mb-1"> بهبود در بخش تیکت ها </li>
            <li class="text-secondary mb-1"> بهبود در قسمت تماس ها مشتریان </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0083 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> اضافه شدن فیلتر بایگانی به تماس های مشتری</li>
            <li class="text-secondary mb-1"> بهبود در گزارش امتیاز مشتریان </li>
            <li class="text-secondary mb-1"> بهبود در ویرایش پیش فاکتور </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0082 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود فرم های مدال </li>
            <li class="text-secondary mb-1"> بهبود مرکز فایل </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0081 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در صفحه دانلود فایل های مشتری </li>
            <li class="text-secondary mb-1"> بهبود گزارش لیست بدهکاران </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0080 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در صفحه تیکت های مشتری</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
     <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0079 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در بارگذاری صفحات</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0077 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در گزارش بازاریابی</li>
            <li class="text-secondary mb-1"> بهبود گزارش تیکتینگ </li>
            <li class="text-secondary mb-1">  ارسال پیامک برای مشتری به هنگام تغییر وضعیت تیکت </li>
            <li class="text-secondary mb-1"> ارسال پیام خودکار در تیکت </li>
            <li class="text-secondary mb-1"> نمایش تعداد پیام ها داخل هر تیکت </li>
            <li class="text-secondary mb-1"> بهبود پنجره تغییر وضعیت تیکت در حالت موبایل </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0076 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در صفحه مشتریان</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0075 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در صفحه تیکت ها </li>
            <li class="text-secondary mb-1"> بهبود صفحه مشتریان </li>
            <li class="text-secondary mb-1"> بهبود در صفحه ویرایش محصولات </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0074 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در گزارش سررسید قرارداد ها </li>
            <li class="text-secondary mb-1"> امکان باز کردن فرم مشتریان در تب  جداگانه </li>
            <li class="text-secondary mb-1"> بهبود مدیریت کارها در مشاهده تماس ها و پرسنل در همان صفحه </li>
            <li class="text-secondary mb-1"> بهبود در عملکرد کلی سیستم </li>
            <li class="text-secondary mb-1"> بهبود عملکرد صفحه فاکتورها </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0073 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> اضافه شدن امکان خروجی اکسل به صفحه تیکت ها </li>
            <li class="text-secondary mb-1"> بهبود صفحه تیکت ها  </li>
            <li class="text-secondary mb-1"> اعمال فیلتر صفحه تیکت ها بروی صفحه چت  </li>
            <li class="text-secondary mb-1"> بهبود ارجاع تیکت در صفحه تیکت ها </li>
            <li class="text-secondary mb-1"> بهبود بارگذاری فایل های مشتری و امکان حذف آن ها </li>
            <li class="text-secondary mb-1"> اضافه شدن گزارش جامع از فعالیت تیکت ها </li>
            <li class="text-secondary mb-1"> امکان انتخاب چندگانه در صفحه تیکت ها </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0071 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> رفع مشکل فیلتر مربوط به مشتری در تیکت  </li>
            <li class="text-secondary mb-1"> اضافه شدن مرور فایلهای مشتری در نامه و فایل ها </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0070 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در منوهای سامانه</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0069 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در بخش های صفحه تیکت و لیست تیکت ها</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0068 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود گزارش قرارداد های بدون فاکتور</li>
            <li class="text-secondary mb-1"> بهبود فرم کارها </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0067 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> بهبود در منوهای سه سطحی </li>
            <li class="text-secondary mb-1"> بهبود در پیش فاکتور ها </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 1.1.0066 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> سه سطحی شدن ساختار منوهای سامانه</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0065 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1"> اضافه شدن امکان پاسخ به چت های تیکت </li>
            <li class="text-secondary mb-1"> بهبود در تب قرارداد مشتریان و امکان ویرایش هر محصول </li>
            <li class="text-secondary mb-1"> بهبود گزارش بدهکاران </li>
            <li class="text-secondary mb-1"> اضافه شدن نمودار نوع تیکت ها </li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0064 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد کلی برنامه</li>
            <li class="text-secondary mb-1">بهبود عملکرد صفحه فاکتورها</li>
            <li class="text-secondary mb-1">اضافه شدن فیلتر نوع تیکت به فیلتر جستوجو]</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0063 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود ماژول تیکت</li>
            <li class="text-secondary mb-1">بهبود گزارش مشتریان مشابه</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0062 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن ضفحه های فاکتورهای من و پیش فاکتورهای من به طرف مشتری</li>
            <li class="text-secondary mb-1">تغییر ترتیب امتیاز کابران</li>
            <li class="text-secondary mb-1">بهبود در محاسبه میانگین زمان پاسخ اول</li>
            <li class="text-secondary mb-1">بهبود در تیکت ها</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>

    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0061 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود ماژول تیکت</li>
            <li class="text-secondary mb-1">بهبود گزارش گردش حساب</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0060 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود ماژول تیکت</li>
            <li class="text-secondary mb-1">اضافه شدن شماره فاکتور به تب قرارداد مشتری</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0059 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود جستجوی پیشرفته</li>
            <li class="text-secondary mb-1">اضافه شدن مرتب سازی به جدول تیکت ها</li>
            <li class="text-secondary mb-1">اضافه شدن وضعیت بایگانی به تیکت ها</li>
            <li class="text-secondary mb-1">رفع شدن محدودیت مشاهده دپارتمان ها</li>
            <li class="text-secondary mb-1">اضافه شدن حذف و ویرایش یادداشت در تیکت ها</li>
            <li class="text-secondary mb-1">بهبود نمودارهای پیشخوان</li>
            <li class="text-secondary mb-1">بهبود عملکرد جستجوی مشتری و تیکت ها</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0058 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن فرم لیست قیمت</li>
            <li class="text-secondary mb-1">اضافه شدن امکان کپی لیست قیمت</li>
            <li class="text-secondary mb-1">اضافه شدن دکمه تیکت های مشتری در صفحه مشتری</li>
            <li class="text-secondary mb-1">اضافه شدن دکمه کـارهـای من در منوی بالا</li>
            <li class="text-secondary mb-1">اضافه شدن ستون فعال در لیست کاربران</li>
            <li class="text-secondary mb-1">بهبود در تیکت ها</li>
            <li class="text-secondary mb-1">بهبود در پیش فاکتور</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0056 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن خرید سرویس شارژ پیامک برای مشتریان</li>
            <li class="text-secondary mb-1">بهبود عملکرد ماژول تیکت</li>
            <li class="text-secondary mb-1">لینک شدن تیکت ها در منوی کاربر</li>
            <li class="text-secondary mb-1">اضافه شدن دکمه اطلاعات تیکت در چت مسیج</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0055 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد ماژول تیکت</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0054 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد گزارش بدهکاران</li>
            <li class="text-secondary mb-1">بهبود عملکرد گزارش سررسید قراردادها</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0053 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد ماژول تیکت</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0052 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد ماژول تیکت</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0050 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد کارتابل قرارداها</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0048 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">امکان تغییر دپارتمان تیکت</li>
            <li class="text-secondary mb-1">امکان تایید قرارداد ها در تب قرارداد های مشتری</li>
            <li class="text-secondary mb-1">اضافه شدن ورود دو مرحله ایی به سامانه</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0047 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن امکان حذف فاکتور</li>
            <li class="text-secondary mb-1">اضافه شدن انتخاب زیر نویس به فاکتور و پیش فاکتور</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0046 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد ثبت قرارداد و فاکتور مشتری</li>
            <li class="text-secondary mb-1">بهبود عملکرد ماژول ایمیل</li>
            <li class="text-secondary mb-1">ثبت نظر در هنگام مشاهده نکات کاری اضافه</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.1.0045 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن ماژول ارسال و دریافت ایمیل</li>
            <li class="text-secondary mb-1">بهبود کد قفل سخت افزاری</li>
            <li class="text-secondary mb-1">اضافه شدن امکان PWA</li>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0044 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">امکان ادعام تیکت ها</li>
            <li class="text-secondary mb-1">بهبود گزارش توسعه</li>
            <li class="text-secondary mb-1">بهبود کد ماژول</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0043 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">تبدیل پیش فاکتور به قرداد</li>
            <li class="text-secondary mb-1">صدور فاکتور به محض ثبت قرداد</li>
            <li class="text-secondary mb-1">امکان ادغام تیکت ها</li>
            <li class="text-secondary mb-1">امکان حذف پیام تیکت</li>
            <li class="text-secondary mb-1">عدم امکان حذف پیام دیده شده</li>
            <li class="text-secondary mb-1">امکان collapse فیلتر های تیکت</li>
            <li class="text-secondary mb-1">نمایش مسئول تیکت به مشتری</li>
            <li class="text-secondary mb-1">اضافه شدن تب تیکت های دپارتمان در صفحه چت روم</li>
            <li class="text-secondary mb-1">Real Time شدن تب تیکت های دپارتمان</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0042 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد ارسال پیامک کاربران تیکت</li>
            <li class="text-secondary mb-1">بهبود گزارش فروش تفکیکی</li>
            <li class="text-secondary mb-1">بهبود عملکرد اندیکاتور</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0041 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود نمایش فرم مشاهده کنندگان نکات کاری</li>
            <li class="text-secondary mb-1">بهبود عمکرد صفحه بندی جداول</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0040 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد صفحه چت روم</li>
            <li class="text-secondary mb-1">اضافه شدن رفرش به چت روم</li>
            <li class="text-secondary mb-1">اضافه شدن قابلیت هایپر لینک به چت روم</li>
            <li class="text-secondary mb-1">بهبود عمکرد صفحه بندی جداول</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0038 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد کارتابل قرارداد</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0037 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن فیلتر نیاز به پاسخ به مدیریت کـارهـا</li>
            <li class="text-secondary mb-1">اضافه شدن نکات کاری به میز کار</li>
            <li class="text-secondary mb-1">بهبود فرم گردش حساب</li>
            <li class="text-secondary mb-1">بهبود فرم مشتریان</li>
            <li class="text-secondary mb-1">بهبود مرتب سازی جداول</li>
            <li class="text-secondary mb-1">امکان اصلاح محصولات قرارداد</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0036 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود فرم تماسها</li>
            <li class="text-secondary mb-1">باز شدن جزئیات قراداد در کارتبل در مودال</li>
            <li class="text-secondary mb-1">بهبود عملکرد لیست بدهکاران</li>
            <li class="text-secondary mb-1">اضافه شده خروجی اکسل به گزارش فروش</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0034 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شد فرم ثبت نکات کاری</li>
            <li class="text-secondary mb-1">تایید تاریخ وصول چک ها</li>
            <li class="text-secondary mb-1">بهبود عملکرد تنظیمات مالی مشتری</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0033 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">تغییرات در ثبت فاکتور حسابداری</li>
            <li class="text-secondary mb-1">نمایش کـارهـا در میز کار کاربران</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0032 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">چاپ پیش فاکتور غیررسمی در قالب جدید</li>
            <li class="text-secondary mb-1">بهبود عملکرد تب نامه ها و فایل ها</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0031 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود گزارش سررسید قرارداد ها</li>
            <li class="text-secondary mb-1">اضافه شدن حذف پیش فاکتور</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0030 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">امکان پرینت جداول اضافه گردید</li>
            <li class="text-secondary mb-1">بهبود عملکرد گزارش سررسد قرارداد ها</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0029 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">ثبت توضیحات در پیش فاکتور</li>
            <li class="text-secondary mb-1">بهبود در ثبت و تغییرات در فرم های نرم افزار</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0028 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود گزارش فروش</li>
            <li class="text-secondary mb-1">بهبود فرم مدیریت قرارداد</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0027 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">امکان اصلاح ماژول</li>
            <li class="text-secondary mb-1">دسترسی بر روی تب ماژول</li>
            <li class="text-secondary mb-1">بهبود عملکرد جستجوی پیشرفته</li>
            <li class="text-secondary mb-1">افزودن فیلد نوع فاکتور برای جستجوی فاکتور ها</li>
            <li class="text-secondary mb-1">جستجو نام مشتری در جستجوی پیشرفته</li>
            <li class="text-secondary mb-1">بهبود گزارش بازاریابی</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0026 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود گزارش لیست بدهکاران</li>
            <li class="text-secondary mb-1">بهبود گزارش فروش</li>
            <li class="text-secondary mb-1">رفع ویرایش پیام مسنجر</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0025 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود فرم کـارهـا در قسمت مشتریان</li>
            <li class="text-secondary mb-1">رفع مشکلات پیش فاکتور</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0024 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">بهبود عملکرد فرم کـارهـای من</li>
            <li class="text-secondary mb-1">بهبود فرم قرارداد ها</li>
            <li class="text-secondary mb-1">بهبود فرم کارتابل قرارداد ها</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0023 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن ستون کد بازاریابی به لیست کـارهـای من</li>
            <li class="text-secondary mb-1">اضافه شدن فرم عودت واریزی</li>
            <li class="text-secondary mb-1">بهبود عملکرد فرم کـارهـای من</li>
            <li class="text-secondary mb-1"></li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0022 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">تغییر متد قرمز شدن مشتریان</li>
            <li class="text-secondary mb-1">اضافه شدن امکان حذف واریزی در همان روز توسط ثبت کننده</li>
            <li class="text-secondary mb-1">تغییر گزارش بدهکاران بر اساس مقدار عدم پرداخت بدهی</li>
            <li class="text-secondary mb-1">بهبود و اصلاح گزارش فروش</li>
            <li class="text-secondary mb-1">اضافه شدن سطر جمع به جداول</li>
            <li class="text-secondary mb-1">ایجاد تغییر و چاپ پیش فاکتور</li>

            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0021 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">گزارش قراردادهای بدون فاکتور</li>
            <li class="text-secondary mb-1">اضافه شدن گزینه عدم پرداخت بدهی مشتری</li>
            <li class="text-secondary mb-1">گزارش توسعه</li>
            <li class="text-secondary mb-1">گزارش بازاریابی</li>
            <li class="text-secondary mb-1">امتیاز مشتری</li>
            <li class="text-secondary mb-1">امکان افزودن تابلو اعلانات برای مشتریان و کارمندان ، هم کلی و هم به تفکیک کارمند</li>
            <li class="text-secondary mb-1">افزودن ثبت فاکتور و مدیریت فاکتور ها</li>
            <li class="text-secondary mb-1">امکان ارسال ایمیل و مدیریت ایمیل ها</li>
            <li class="text-secondary mb-1">تغییر حالت واریزی ها و چیدمان واریزی ها</li>
            <li class="text-secondary mb-1">اضافه شدن پیام رسان داخلی</li>
            <li class="text-secondary mb-1">محدود کردن کارمند براساس ایام هفته</li>

            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0020 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">خواندن کابران بر اساس دپارتمان انتخاب شده</li>
            <li class="text-secondary mb-1">دائمی شدن فیلد های جستوجوی تیکت</li>
            <li class="text-secondary mb-1">تغییر رنگ تیکت مشاهده شده</li>

            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0019 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن امکان گذاشتن یادآوری برای کاربران</li>
            <li class="text-secondary mb-1">رفع مشکل پاسخ کـارهـا</li>
            <li class="text-secondary mb-1">جستجوی پیشرفته</li>
            <li class="text-secondary mb-1">تابلو اعلانات</li>
            <li class="text-secondary mb-1">گزارش سررسید قراردادها</li>
            <li class="text-secondary mb-1">کاتالوگ</li>
            <li class="text-secondary mb-1">خرید شارژ پیامک برای مشتریان</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0013 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">اضافه شدن پیامک های اماده به ارسال پیامک کاربران CRM</li>
            <li class="text-secondary mb-1">اصلاح نمودار امتیاز پشتیبانی</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0012 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">امتیاز دهی به کاربران تیکت</li>
            <li class="text-secondary mb-1">امکان ارسال چند پیویست در تیکت</li>
            <li class="text-secondary mb-1">بهبود رابط کاربری موبایل</li>
            <li class="text-secondary mb-1">اضافه شده پاسخ های آماده به ارسال تیکت</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0011 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">نمودار پراکندگی تیکت ها</li>
            <li class="text-secondary mb-1">نمودار تماس ها</li>
            <li class="text-secondary mb-1">گزارش لیست بدهکاران</li>
            <li class="text-secondary mb-1">نمودار تیکت های من</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>

    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0010 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">منو های کاربردی</li>
            <li class="text-secondary mb-1">پروفایل مشتریان</li>
            <li class="text-secondary mb-1">پروفایل کاربران</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>

    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0009 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">دپارتمان تیکت</li>
            <li class="text-secondary mb-1">یادداشت ها و پیوست ها</li>
            <li class="text-secondary mb-1">اولویت تیکت</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0008 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">ماژول تیکتینگ</li>
            <li class="text-secondary mb-1">ایجاد تیکت</li>
            <li class="text-secondary mb-1">مشاهده تیکت</li>
            <li class="text-secondary mb-1">جستوجو تیکت</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>

    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0007 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">گزارش هشدار کاربران</li>
            <li class="text-secondary mb-1">گزارش جست و جو مشتریان</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>

    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0006 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">پیامک مشتریان</li>
            <li class="text-secondary mb-1">پیام های آماده</li>
            <li class="text-secondary mb-1">اندیکاتور</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>

    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0005 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">ثبت محصول</li>
            <li class="text-secondary mb-1">ثبت موارد پرسشنامه</li>
            <li class="text-secondary mb-1">فرم ثبت اطلاعات پایه</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>

    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0004 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">ثبت تماس</li>
            <li class="text-secondary mb-1">ثبت حضور</li>
            <li class="text-secondary mb-1">ثبت قرارداد</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>

    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0003 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">فرم ثبت آدرس ها</li>
            <li class="text-secondary mb-1">قرم ثبت اطلاعات ارتباطی</li>
            <li class="text-secondary mb-1">فرم ثبت هشدار</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>

    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0002 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">ثبت مشتریان</li>
            <li class="text-secondary mb-1">ویرایش مشتری</li>
            <li class="text-secondary mb-1">مدیریت محصولات</li>
            <li class="text-secondary mb-1">Crm ثبت کاربران</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">لیست تغییرات نسخه : [ 0.0.0001 ]</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-8">
            <li class="text-secondary mb-1">باگذاری نسخه پایه</li>
            <li class="text-secondary mb-1">پیاده سازی فرم ورود</li>
            <li class="text-secondary mb-1">پیاده سازی دسترسی به امکانات</li>
            <hr id="styleHr" />
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2"></div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Widget from '@/components/Widget/Widget.vue'
import Card from '@/components/Card/Card.vue'
export default {
  data(){
    return{
      
    }
  },
  components: { Widget, Card },
}
</script>
<style scoped>
#styleHr {
  border-top: 1px solid #002b49;
}
</style>
